<div class="d-none d-md-flex sidebar position-relative flex-column h-100"
     [ngClass]="{'sidebar-collapsed': sidebarCollapsed}">
    <div class="p-25 d-flex flex-column gap-2">
        <app-button
                size="lg"
                variant="warning"
                class="w-100"
                (click)="addClient()"
                [icon]="sidebarCollapsed ? 'users' : null"
        >
            <span *ngIf="!sidebarCollapsed">{{ 'Add Client'|translate }}</span>
        </app-button>
        <app-search-input
                *ngIf="!sidebarCollapsed"
                [(ngModel)]="searchName"
                [placeholder]="('Search'|translate) + ' ' + ('Clients'|translate)"
                class="w-100 sidebar-search"
        ></app-search-input>
    </div>
    <div class="d-flex flex-column h-100 mh-0 gap-1">
        <div class="d-flex justify-content-between align-items-center">
            <div [ngClass]="{'invisible w-0': sidebarCollapsed}" class="dropdown ps-25" dropdown
                 placement="bottom right">
                <div class="text-white dropdown-toggle cursor-pointer text-center" dropdownToggle>
                    {{ integrationLabels[selectedIntegration] }}
                </div>
                <div class="dropdown-menu dropdown-menu-start ms-2" *dropdownMenu>
                    <div *ngFor="let item of integrationFilterItems" class="dropdown-item position-relative text-white"
                         [ngClass]="{'dropdown-item-selected': this.selectedIntegration === item.key}"
                         (click)="selectedIntegration = item.key; load();">{{ item.label }}
                    </div>
                </div>
            </div>
            <button class="sidebar-collapse-btn" (click)="sidebarCollapsed = !sidebarCollapsed;">
                <i class="fa fa-angles-{{sidebarCollapsed ? 'right' : 'left'}}"></i>
            </button>
        </div>
        <div class=" mh-0 overflow-y-auto clients-container">
            <ng-container *ngIf="!sidebarCollapsed">
                <ng-template [ngIf]="loading" [ngIfElse]="data">
                    <div class="d-flex justify-content-center">
                        <mat-spinner color="white" diameter="40"></mat-spinner>
                    </div>
                </ng-template>
                <ng-template #data>
                    <div
                            appUserGuide
                            guideId="ADD_BANK"
                            [guideTitle]="guideKeys.workWithClient.title"
                            [guideText]="guideKeys.workWithClient.text1"
                            guideButtonCaption="NEXT"
                            [guideStep]="1"
                            [guideNextHandler]="nextGuideStep"
                            class="ps-25 d-flex flex-column"
                    >
                        <ng-container *ngFor="let client of clients | searchName : searchName : ['name', 'seek']">
                            <div class="d-flex text-ellipsis position-relative" [ngClass]="{
                                'item-container cursor-pointer': !client.isFirm,
                                'item-container-active': (selectedClient && client.username === selectedClient?.username),
                                'd-none': collapsedFirms.includes(client.clientGroupId) && !searchName
                            }"
                                 (click)="!client.isFirm && onSelectClient(client)"
                            >
                                <div *ngIf="(selectedClient && client.username === selectedClient?.username)"
                                     class="item-marker position-absolute top-0 bottom-0"></div>
                                <div
                                        class="p-1 mw-0 d-flex gap-1"
                                        [ngClass]="{
                                        'ps-0 firm-item': client.isFirm,
                                        'ps-2': !client.isFirm,
                                        'ps-4': client.isClientWithFirm,
                                    }"
                                        title="{{client.name}}"
                                >
                                    <div class="text-ellipsis">
                                        {{ client.name }}
                                    </div>
                                    <div class="firm-expander {{client.collapsed && !searchName && 'collapsed'}}" *ngIf="client.isFirm"
                                         (click)="toggle(client)">
                                        <svg class="w-6 h-6 text-gray-800 dark:text-white {{!searchName && 'cursor-pointer'}}"
                                             aria-hidden="true"
                                             xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                             viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                                  stroke-width="2" d="m8 10 4 4 4-4"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-template>
            </ng-container>
        </div>
    </div>
</div>
